import React, { useEffect } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { categoryAddEdit } from "../../../../services/catagoryService";

const validation = {
  name: { required: true, message: "Title is required" },
};

const ManageCategory = ({
  getResponse = () => {},
  close = () => {},
  data,
  type,
}) => {
  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
    }
  }, [data]);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      name: "",
      type: type,
    },
  });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await categoryAddEdit({
        ...val,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4">
        <div className="relative col-span-4">
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <Input
                label="Category Name"
                inputPlaceholder={"Enter Category Name"}
                inputName="name"
                value={values?.name}
                onChange={handleChange}
                {...formValidate(errors, "name")}
              />
            </div>
          </div>
          <div className="relative col-span-4 mt-5">
            <div className="flex items-center justify-center gap-4">
              <Button
                buttonType="submit"
                buttonLabel={"Save"}
                buttonClasses={
                  "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
                }
                buttonLabelClasses={"mx-auto"}
                {...(isLoading && {
                  loading: true,
                  buttonIconPosition: "left",
                  isDisable: true,
                })}
              />
              <Button
                buttonLabel={"Cancel"}
                buttonClasses={
                  "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
                }
                buttonLabelClasses={"mx-auto"}
                buttonFunction={close}
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ManageCategory;
